export const IS_SLIDE_IMAGES_ID = "isSlideImagesId";

export const setSlideImagesId = (value: string): void => {
  localStorage.setItem(IS_SLIDE_IMAGES_ID, value);
};

export const getSlideImagesId = (): string => {
  return localStorage.getItem(IS_SLIDE_IMAGES_ID);
};

export const removeSlideImagesId = (): void => {
  localStorage.removeItem(IS_SLIDE_IMAGES_ID);
};
